import React, { useState, useEffect } from 'react';
import { Typography, } from '@mui/material'
import Grid from '@mui/material/Grid';
import MDTextField from './MDTextField';
import AsyncReactSelect from './AsyncReactSelect';
import { set } from 'date-fns';

function Person(props) {
  const [person, setPerson] = useState(props.person);
  const [business, setBusiness] = useState(props.business);
  const [summary, setSummary] = useState(props.summary);
  const [thirdParty, setThirdParty] = useState(props.thirdParty);
  const [shiprecv, setShiprecv] = useState(props.shiprecv);
  const [reviewPage, setReviewPage] = useState(props.reviewPage);

  const [visaFilled, setVisaFilled] = useState(false);
  const [uniqId, setUniqId] = useState('');
  const [error, setError] = useState(false);
  const [errorText, setErrorText] = useState('');

  const [requiredFields, setRequiredFields] = useState({first: props.reviewPage? true : false, last: props.reviewPage? true : false, business: props.reviewPage? true : false, 
                dob: props.reviewPage? true : false, coc: props.reviewPage? true : false, idnum: props.reviewPage? true : false, 
                passport: props.reviewPage? true : false, passportCountry: props.reviewPage? true : false, visaDate: props.reviewPage? true : false, 
                visaIssued: props.reviewPage? true : false, alienNumber: props.reviewPage? true : false});
  const [passportreq, setPassportreq] = useState(props.person.passportreq);
  const [idreq, setIdreq] = useState(props.person.idreq);
  const [alienreq, setAlienreq] = useState(props.person.alienreq);

  const { locator, thirdpartylocator, mailshiplocator } = props

  useEffect(() => {
    setPerson(props.person)
  }, [props.person])
  useEffect(() => {
    setBusiness(props.business)
  }, [props.business])
  useEffect(() => {
    setSummary(props.summary)
  }, [props.summary])

  useEffect(() => {
    if(props.person.passportreq === false && props.person.passportreq !== person.passportreq) {
      setPassportreq(false)
    } 
    if(props.person.idreq === false && props.person.idreq !== person.idreq) {
      setIdreq(false)
    } 
    if(props.person.alienreq === false && props.person.alienreq !== person.alienreq) {
      setAlienreq(false)
    } 
  }, [props.reviewPage, props.person])


  const handleChange = (propertyName, value) => {
    // console.log(JSON.stringify(propertyName) + ' ' + JSON.stringify(value))
    // const { person, thirdParty, requiredFields } = this.state;
    const newPerson = {
      ...person,
      [propertyName]: value,
    };
    // console.log(JSON.stringify(requiredFields) + ' -- ' + JSON.stringify(person))
    if ((propertyName === 'dob' || propertyName === 'visaDate') 
        && (Object.prototype.toString.call(value) === "[object Date]") && !isNaN(value.valueOf())
        && newPerson.dob !== null && newPerson.visaDate !== null && newPerson.dob !== '' && newPerson.visaDate !== ''
        && requiredFields.dob) {
      const dobD = newPerson.dob
      const visaDateD = newPerson.visaDate

      if (dobD > visaDateD) {
        setError(true)
        setErrorText('U.S. Visa Date should be after Date of Birth')
        const newRequiredFields = {
          ...requiredFields,
          visaDate: false
        };
        setRequiredFields(newRequiredFields);
        props.handleError('person', false);
        // this.setState({ error: true, errorText: 'U.S. Visa Date should be after Date of Birth' });
        // this.handleError('visaDate', true)
      } else {
        setError(false)
        setErrorText('')
        const newRequiredFields = {
          ...requiredFields,
          visaDate: true
        };
        setRequiredFields(newRequiredFields);
        props.handleError('person', true);
        // this.setState({ error: false, errorText: '' });
        // this.handleError('visaDate', false)
      }
    }

    // if (propertyName === 'visaDate') {
    //   setError(false)
    //   setErrorText('')
    // }

    if (newPerson.visaDate !== '') {
      setVisaFilled(true)
    } else {
      setVisaFilled(false)
    }

    if (propertyName === "first" && value !== undefined) {
      newPerson.first = value.charAt(0).toUpperCase() + value.slice(1);
    } 
    if (propertyName === "last" && value !== undefined) {
      newPerson.last = value.charAt(0).toUpperCase() + value.slice(1);
    }
    if (propertyName === "middle" && value !== undefined) {
      newPerson.middle = value.charAt(0).toUpperCase() + value.slice(1);
    }
    if(propertyName === "businessTypeOrProfession" && value !== undefined) {
      newPerson.businessTypeOrProfession = value.charAt(0).toUpperCase() + value.slice(1);
    }

    var newRequiredFields;

    if (!thirdParty && person.coc !== undefined && person.coc.value === 'USA') {
      if (propertyName === 'passport') {        
        newRequiredFields = {...requiredFields, idnum: value !== ''? true : false, passportCountry: value !== ''? true : false};   
        setIdreq(value !== ''? false : true)
          setRequiredFields(newRequiredFields)

        if(newPerson.idreq===true && value!==''){
          newPerson.idreq= false 
      }
      }      
      if (propertyName === 'idnum') {
        newRequiredFields = {...requiredFields, passport: value !== ''? true : false, passportCountry: value !== ''? true : false};
        setPassportreq(value !== ''? false : true)
        setRequiredFields(newRequiredFields)

        if(newPerson.passportreq===true && value!==''){
          newPerson.passportreq= false
        }
      }
    } else if (!thirdParty && person.coc !== '') {
      if (propertyName === 'passport') {
        newRequiredFields = {...requiredFields, idnum: value !== ''? true : false, passportCountry: value !== ''? true : false, alienNumber: value !== ''? true : false};  
        setIdreq(value !== ''? false : true)
        setAlienreq(value !== ''? false : true)
        setRequiredFields(newRequiredFields)

        if(newPerson.idreq===true && value!==''){
          newPerson.idreq= false
        }if((newPerson.alienreq===true && value!=='')){
          newPerson.alienreq=false
        }
      }
      if (propertyName === 'idnum') {        
        newRequiredFields = {...requiredFields, passport: value !== ''? true : false, passportCountry: value !== ''? true : false, alienNumber: value !== ''? true : false};
        setPassportreq(value !== ''? false : true)
        setAlienreq(value !== ''? false : true)
        setRequiredFields(newRequiredFields)
        
        if(newPerson.passportreq===true && value!==''){
          newPerson.passportreq= false
        }if((newPerson.alienreq===true && value!=='')){
          newPerson.alienreq=false
        }
      }
      if (propertyName === 'alienNumber') {
        newRequiredFields = {...requiredFields, idnum: value !== ''? true : false, passport: value !== ''? true : false, passportCountry: value !== ''? true : false}; 
        setPassportreq(value !== ''? false : true)
        setIdreq(value !== ''? false : true)
        setRequiredFields(newRequiredFields)
        if(newPerson.idreq===true && value!==''){
          newPerson.idreq= false
        }if((newPerson.passportreq===true && value!=='')){
          newPerson.passportreq=false
        }
      }
    }

    // console.log('person in person ' + JSON.stringify(newPerson))

    setPerson(newPerson)
    props.updatePerson(newPerson);
  }

  const handleError = (propertyName, inerror) => {
    var allReqDone = false;
    setError(false)

    const newRequiredFields = {
      ...requiredFields,
      [propertyName]: !inerror,
    };

    // console.log(JSON.stringify(newRequiredFields) + ' /bef--/ ' + JSON.stringify(propertyName))

    // if ((propertyName === 'dob' || propertyName === 'visaDate')
    // if ((propertyName === 'datecomp')    
    //       && newRequiredFields.dob && newRequiredFields.visaDate) {

      // if (person.dob > person.visaDate) {
      //   setError(true)
      //   setErrorText('U.S. Visa Date should be after Date of Birth')
      //   newRequiredFields.visaDate = false;
      //   allReqDone = false;
      // } else {
      //   allReqDone = checkAllReqDone(newRequiredFields);
      // }
    // } else {
      // if (propertyName !== 'dob' && propertyName !== 'visaDate') {
        allReqDone = checkAllReqDone(newRequiredFields);
      // }      
    // }

    // console.log('mailshiplocator ' + this.props.mailshiplocator);
    if (props.mailshiplocator !== undefined && props.mailshiplocator  !== 'mailship') {
      props.handleError(props.mailshiplocator, allReqDone && !error);
    } else {
      props.handleError('person', allReqDone && !error);
    }

    // console.log(JSON.stringify(newRequiredFields) + ' /--/ ' + JSON.stringify(propertyName))
    setRequiredFields(newRequiredFields)
    
    // console.log('allReqDone ' + allReqDone);
  }

  const checkAllReqDone = (newRequiredFields) => {
    var allReqDone = false;
    if (thirdParty) {
      if (props.business) {
        if (newRequiredFields.business) {
          allReqDone = true;
        }
      } else {
        if (newRequiredFields.first && newRequiredFields.last) {
          allReqDone = true;
        }
      }
    } else if (shiprecv) {
      if (props.business) {
        if (newRequiredFields.business) {
          allReqDone = true;
        }
      } else {
        if (newRequiredFields.first && newRequiredFields.last) {
          allReqDone = true;
        }
      }      
    } else if (props.business) {
      if (newRequiredFields.business && newRequiredFields.idnum) {
        allReqDone = true;
      }
    } else if (person.coc !== null && (person.coc.value === 'USA' || person.coc.visaWaiver === 'Y')) {
      if (newRequiredFields.first && newRequiredFields.last && newRequiredFields.dob && newRequiredFields.coc 
        && (newRequiredFields.idnum || (newRequiredFields.passport && newRequiredFields.passportCountry))) {
        allReqDone = true;
      }
    } else if (newRequiredFields.first && newRequiredFields.last && newRequiredFields.dob && newRequiredFields.coc
       && (newRequiredFields.idnum || (newRequiredFields.passport && newRequiredFields.passportCountry) || newRequiredFields.alienNumber) 
       && newRequiredFields.visaDate && newRequiredFields.visaIssued) {
      allReqDone = true;
    }
    return allReqDone;
  }

  // const { classes,locator,thirdpartylocator,mailshiplocator } = this.props
  // const { person, business, summary, thirdParty, shiprecv, passportreq, idreq, alienreq, visaFilled ,error, errorText } = this.state
  return (
    <div>
      <Grid container sx={{ flexDirection: 'row', alignItems: 'center' }}>
        {(business) &&
          <MDTextField name='business' label='Business Name' value={person.business} handleChange={handleChange}
              handleError={handleError} required={true} wide={true} 
              inputProps={{ maxLength: 95, id: locator === 'Review'? 'business' + locator : 'business' }} summary={summary} />
        }
          {(business && !thirdParty && !shiprecv) &&
        <Grid container sx={{ flexDirection: 'row', alignItems: 'center' }}>             
            <MDTextField name='idnum' label='Identification Number' value={person.idnum} handleChange={handleChange} 
              handleError={handleError} required={true} inputProps={{maxLength: 20, id: locator === 'Review'? 'idnum' + locator : 'idnum'}} summary={summary} /> 
          </Grid>
        }
        
        {(!business) &&
        <MDTextField name='first' label='First Name' value={person.first} handleChange={handleChange} 
            handleError={handleError} required={true} 
            inputProps={{ maxLength: 44, id: locator === 'Review'? 'firstName' + locator: thirdpartylocator === 'thirdparty'? 
            'firstName' + thirdpartylocator : mailshiplocator  === 'mailship'? 'firstName' + mailshiplocator : 'firstname' }} summary={summary} />
        }
        {(!business) &&
        <MDTextField name='last' label='Last Name' value={person.last} handleChange={handleChange} 
            handleError={handleError} required={true}  inputProps={{ maxLength: 95, 
              id:locator === 'Review'? 'lastName' + locator : thirdpartylocator === 'thirdparty'? 'lastName' + thirdpartylocator : mailshiplocator === 'mailship'? 
              'lastName' + mailshiplocator : 'lastName' }} summary={summary} />
        }
        {(!business) &&
        <MDTextField name='middle' label='Middle Name' value={person.middle} handleChange={handleChange} 
            handleError={handleError} required={false} 
            inputProps={{ maxLength: 40, id: locator === 'Review'? 'MiddleName' + locator : thirdpartylocator === 'thirdparty'?
              'MiddleName' + thirdpartylocator : mailshiplocator === 'mailship'? 'MiddleName' + mailshiplocator : 'MiddleName'}} summary={summary} />
        }

        {(!thirdParty && !shiprecv && !business) &&
          <MDTextField name='dob' id='date' label='Date of Birth' value={person.dob} type='date' inputLabelProps={{ shrink: true }}
              handleChange={handleChange} handleError={handleError} required={true} inputProps={{ id:locator === 'Review'? 'date' + locator : 'date'}} summary={summary} />
        }
        {(thirdParty) &&
          <MDTextField name='businessTypeOrProfession' label='Profession/Type' value={person.businessTypeOrProfession} handleChange={handleChange} 
              handleError={handleError} required={false}  inputProps={{ maxLength: 30, id: locator === 'Review'?
                'businessTypeOrProfession' + locator : 'businessTypeOrProfession'}} summary={summary} />
        }
      </Grid>
        
      {(!thirdParty && !shiprecv && !business) &&
        <Grid container sx={{ flexDirection: 'row', alignItems: 'center' }}>
          <AsyncReactSelect name='coc' label='Citizenship' value={person.coc} placeholder='Search for Citizenship' errorText='Please select Citizenship'
            optionsType='country' handleChange={handleChange} handleError={handleError} required={true} 
            uniqId={locator === 'Review'? 'Citizenship' + locator : 'Citizenship'} disabled={summary ? true : false}  summary={summary} />
          {!thirdParty && !shiprecv && person.coc !== null && person.coc.value !== undefined && person.coc.value !== 'USA' && (
            <Grid sx={{
              marginLeft: 1,
              marginRight: 1,
              width: '12rem',
              borderWidth: '2px',
              borderStyle: 'solid',
              borderColor: 'blue',
              borderRadius: '8px',
            }}>
            <Typography sx={{ align: 'left', fontSize: '10px', paddingLeft: '4px' }}>
                  *Non-US Citizens need to provide<br></br> 
                    - Identification Number (or)<br></br>
                    - Alien Number (or)<br></br>
                    - Passport Number & Passport Country
            </Typography>
            </Grid>
          )}
          <MDTextField name='idnum' label='Identification Number' value={person.idnum} handleChange={handleChange} 
              handleError={handleError} required={idreq}  inputProps={{maxLength: 20, id: locator === 'Review'? 'idnum' + locator : 'idnum'}} summary={summary} />
          {(person.coc !== null && person.coc.value !== 'USA') &&
            <MDTextField name='alienNumber' label='Alien Number' value={person.alienNumber} handleChange={handleChange} 
                handleError={handleError} required={alienreq} inputProps={{maxLength: 30, id: locator === 'Review'? 'alienNumber' + locator : 'alienNumber'}} summary={summary} />
          }

        </Grid>
      }

      {(!thirdParty && !shiprecv && !business) &&
        <Grid container sx={{ flexDirection: 'row', alignItems: 'center' }}>
          <MDTextField name='passport' label='Passport Number' value={person.passport} handleChange={handleChange} 
              handleError={handleError} required={passportreq} inputProps={{maxLength: 20, id:locator === 'Review'? 'passport' + locator : 'passport'}}  summary={summary} />
          <AsyncReactSelect name='passportCountry' label='Passport Country' value={person.passportCountry} placeholder='Search for Issue Country' errorText='Please select Issue Country'
            optionsType='country' handleChange={handleChange} handleError={handleError} required={passportreq} disabled={summary ? true : false} 
            uniqId={locator === 'Review'? 'passportCountry' + locator : 'passportCountry'} summary={summary} />
          {person.coc !== null && person.coc.value !== 'USA' && person.coc.visaWaiver === 'N' &&
            <MDTextField name='visaDate' label='U.S. Visa Date' value={person.visaDate} handleChange={handleChange} 
                handleError={handleError} type='date' inputLabelProps={{ shrink: true }} required={true} inputProps={{maxLength: 20, id: locator === 'Review'? 'visaDate' + locator : 'visaDate'}}  summary={summary}
                error={!visaFilled? undefined : error} errorText={!visaFilled? undefined : errorText } />
          }
          {person.coc !== null && person.coc.value !== 'USA' && person.coc.visaWaiver === 'N' && 
          <MDTextField name='visaIssued' label='U.S. Visa Issued City' value={person.visaIssued} handleChange={handleChange} 
              handleError={handleError} required={true} inputProps={{maxLength: 50, id:locator === 'Review'? 'visaIssued' + locator : 'visaIssued'}} summary={summary} />
          }
          </Grid>
      }
    </div>
  );
}

export default Person;